import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "select-timer-rule"
};
const _hoisted_2 = {
  class: "timer-rule-header mb-10"
};
const _hoisted_3 = {
  class: "btn-group"
};
import { ref, toRefs, computed, onMounted, watch, nextTick } from 'vue';
import { Search, Close, EditPen } from '@element-plus/icons-vue';
import { ElMessage, ElTable } from 'element-plus';
import { mctRequest } from '@/api/axios';
import { storeToRefs } from 'pinia';
import { useSetTimerStore } from '@/store/setTimer';
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectTimerRule',
  props: {
    zoneTestLocation: {}
  },
  setup(__props) {
    const useSetTimer = useSetTimerStore();
    const {
      refreshTimerRule,
      selectTimerRuleDialogVisible,
      refreshSetTimer
    } = storeToRefs(useSetTimer);
    const {
      addTimerRule,
      editTimerRule,
      deleteTimerRole
    } = useSetTimer;
    const props = __props;
    const {
      zoneTestLocation
    } = toRefs(props);
    const filterTimerRule = ref('');
    const tableData = ref([]);
    const initTimerRuleTable = async () => {
      const config = {
        url: '/timerSettingRule/query'
      };
      const {
        timerSettingRuleList
      } = await mctRequest.request(config);
      tableData.value = timerSettingRuleList.map(timerRule => {
        return {
          ruleId: timerRule.ruleId,
          name: timerRule.name,
          interval: interval2Str(timerRule.interval),
          runOfDays: weeksNumber2Str(timerRule.runOfDays),
          timeSlot: startAndEndTime2TimeSlot(timerRule.startMinOfDay, timerRule.endMinOfDay),
          timeZone: timerRule.timeZone
        };
      });
      toggleSelection(zoneTestLocation.value?.timerRule);
    };
    const interval2Str = interval => {
      const intervalNumber = Number(interval);
      if (intervalNumber <= 60) {
        return `every ${intervalNumber} min`;
      } else {
        return `every ${intervalNumber / 60} hour`;
      }
    };
    const weeksNumber2Str = str => {
      const weekMap = {
        2: 'MON',
        3: 'TUE',
        4: 'WED',
        5: 'THU',
        6: 'FRI',
        7: 'SAT',
        1: 'SUN'
      };
      const weekStrArr = str.split(',');
      const weeks = weekStrArr.map(item => weekMap[item]);
      const res = weeks.join(',');
      return res;
    };
    const startAndEndTime2TimeSlot = (start, end) => {
      const fmt = min => {
        const h = Math.floor(min / 60);
        const m = min % 60;
        return `${h}:${m.toString().padStart(2, '0')}`;
      };
      return `${fmt(start)} - ${fmt(end)}`;
    };
    const computedTableData = computed(() => tableData.value.filter(data => !filterTimerRule.value || data?.name.toLowerCase().includes(filterTimerRule.value.toLowerCase())).slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => tableData.value.length);
    const handleSizeChange = val => {
      pageSize.value = val;
    };
    const handleCurrentChange = async () => {
      console.log('handleCurrentChange');
    };
    const multipleTableRef = ref();
    const multipleSelection = ref([]);
    const handleSelectionChange = val => {
      multipleSelection.value = val;
    };
    const handleSubmit = async () => {
      if (!multipleSelection.value?.length) {
        ElMessage({
          type: 'error',
          message: 'Please select timer rule'
        });
        return;
      }
      const ruleList = multipleSelection.value.map(rule => {
        return {
          ruleId: rule.ruleId.toString()
        };
      });
      const config = {
        url: '/timerSettingRule/binding',
        method: 'post',
        data: {
          zoneId: zoneTestLocation.value.zoneId,
          testLocation: zoneTestLocation.value.testLocation,
          timerRuleList: ruleList,
          vGroupId: zoneTestLocation.value.vGroupId,
          orgId: zoneTestLocation.value.orgId
        }
      };
      await mctRequest.request(config);
      ElMessage({
        type: 'success',
        message: 'Successfully added'
      });
      refreshSetTimer.value++;
      selectTimerRuleDialogVisible.value = false;
    };
    const toggleSelection = rows => {
      if (rows) {
        rows.forEach(row => {
          for (const item of computedTableData.value) {
            if (item.ruleId === row.ruleId) {
              nextTick(() => {
                multipleTableRef.value.toggleRowSelection(item, undefined);
              });
            }
          }
        });
      } else {
        multipleTableRef.value.clearSelection();
      }
    };
    watch(() => refreshTimerRule.value, () => {
      initTimerRuleTable();
    });
    onMounted(() => {
      initTimerRuleTable();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _unref(addTimerRule)
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Add Timer Rule")])),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_input, {
        class: "w-50 m-2 filter-table",
        placeholder: "Filter the table",
        modelValue: filterTimerRule.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filterTimerRule.value = $event),
        "prefix-icon": _unref(Search)
      }, null, 8, ["modelValue", "prefix-icon"])]), _createElementVNode("div", null, [_createVNode(_unref(ElTable), {
        ref_key: "multipleTableRef",
        ref: multipleTableRef,
        data: computedTableData.value,
        style: {
          "width": "100%",
          "margin-bottom": "20px"
        },
        "row-key": "id",
        border: "",
        "default-expand-all": "",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "Name"
        }), _createVNode(_component_el_table_column, {
          prop: "interval",
          label: "Interval"
        }), _createVNode(_component_el_table_column, {
          prop: "runOfDays",
          label: "Run of Days"
        }), _createVNode(_component_el_table_column, {
          prop: "timeSlot",
          label: "Time Slot"
        }), _createVNode(_component_el_table_column, {
          prop: "timeZone",
          label: "Time Zone"
        }), _createVNode(_component_el_table_column, {
          prop: "action",
          label: "Action"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "Edit Timer Rule",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: _unref(EditPen),
              type: "primary",
              size: "small",
              circle: "",
              onClick: $event => _unref(editTimerRule)(scope.row.ruleId)
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "Delete Timer Rule",
            placement: "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: _unref(Close),
              type: "danger",
              size: "small",
              circle: "",
              onClick: $event => _unref(deleteTimerRole)(scope.row.ruleId)
            }, null, 8, ["icon", "onClick"])]),
            _: 2
          }, 1024)]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => currentPage.value = $event),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => pageSize.value = $event),
        "page-sizes": [10, 20, 50],
        layout: "total, sizes, prev, pager, next",
        class: "manual-test-pagination",
        total: itemNumber.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        plain: "",
        onClick: _cache[3] || (_cache[3] = $event => selectTimerRuleDialogVisible.value = false)
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" Cancel ")])),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("Submit")])),
        _: 1
      })])]);
    };
  }
});